import { Outlet } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';
import { Header } from './Header';
import { HEADER_HEIGHT } from './layoutConstants';

const useStyles = makeStyles({
  app: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    // Header is position:fixed (out of flow), so pad the shell top by its height.
    paddingTop: HEADER_HEIGHT,
  },
  main: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  },
});

export function AppLayout() {
  const styles = useStyles();
  return (
    <div className={styles.app}>
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
